/**
 * Boardstruktur (Entwicklerbericht „Boards sinnvoll organisieren“).
 *
 * - Ein Bereich gehört zu genau einem Team und hat eigene Struktur-Mitglieder (Verwalter, Mitglied).
 *   Bereichsmitgliedschaft zeigt nur die Struktur – sie gibt KEINEN Zugriff auf Boards.
 * - Ordner: genau eine Ebene im Bereich, ohne eigene Mitglieder.
 * - Ein Board liegt direkt im Bereich, in einem Ordner oder ohne Zuordnung („Nicht einsortiert“).
 * - Favoriten und „Zuletzt geöffnet“ sind persönliche Zugriffe, keine Ablageorte.
 */

export const AREA_ROLES = ['member', 'manager'] as const;
export type AreaRole = (typeof AREA_ROLES)[number];
export const AREA_ROLE_LABELS: Record<AreaRole, string> = { member: 'Mitglied', manager: 'Verwalter' };

/** Ablage eines Boards aus Sicht der angemeldeten Person */
export interface BoardPlacement {
  /** none = Nicht einsortiert; visible = Pfad sichtbar; hidden = liegt in einem Bereich, den die Person nicht sieht („Freigegebenes Board“) */
  kind: 'none' | 'visible' | 'hidden';
  areaId: string | null;
  areaName: string | null;
  folderId: string | null;
  folderName: string | null;
  version: number;
}

export interface NavFolder {
  id: string;
  name: string;
  /** nur für die Person sichtbare, aktive Boards */
  boardCount: number;
}

export interface NavArea {
  id: string;
  teamId: string;
  teamName: string;
  name: string;
  description: string | null;
  myRole: AreaRole;
  /** darf die Struktur verwalten (Verwalter oder Teambesitzer) */
  canManage: boolean;
  /** sichtbare, aktive Boards direkt im Bereich (ohne Ordner) */
  boardCount: number;
  folders: NavFolder[];
  version: number;
}

export interface Navigation {
  areas: NavArea[];
  /** Teams, in denen die Person Bereiche anlegen darf */
  teams: { id: string; name: string }[];
}

export interface AreaMember {
  id: string;
  name: string;
  email: string;
  image: string | null;
  role: AreaRole;
}

/** Pfad als Text: „Kundenprojekte / Kunde Müller“, „Freigegebenes Board“ oder „Nicht einsortiert“ */
export function placementPath(p: BoardPlacement | null | undefined): string {
  if (!p || p.kind === 'none') return 'Nicht einsortiert';
  if (p.kind === 'hidden') return 'Freigegebenes Board';
  return p.folderName ? `${p.areaName} / ${p.folderName}` : (p.areaName ?? '');
}
